<template>
  <form @submit="handleSubmit" action="/" method="post">
    <base-section>
      <h3 v-t="'auth.heading'" />
      <h4 v-t="'auth.subheading'" />
      <br />
      <base-input
        :required="true"
        :placeholder="$t('auth.form.emailFieldPlaceholder')"
        v-model="email"
        id="email"
        type="email"
        @input="isRestorePasswordLinkSent = false"
      />
      <base-input
        :placeholder="$t('auth.form.passwordFieldPlaceholder')"
        v-model="password"
        id="password"
        type="password"
        autofocus="true"
      />
      <section class="restore-password-section">
        <template v-if="!isRestorePasswordLinkSent">
          <a
            class="restore-password-link"
            v-t="'auth.restorePasswordLink.defaultStateText'"
            href="#"
            @click="sendRestorePasswordLink"
          />
        </template>
        <template v-else>
          <p v-t="'auth.restorePasswordLink.successSentMessage'" />
          <p v-if="timeBeforeNextRestoreLinkSend <= 0">
            <a
              class="restore-password-link"
              v-t="'auth.restorePasswordLink.resendStateText'"
              href="#"
              @click="sendRestorePasswordLink"
            />
          </p>
          <p
            v-else
            v-t="{
              path: 'auth.restorePasswordLink.resendCountdownMessage',
              args: { timeBeforeNextRestoreLinkSend },
            }"
          />
        </template>
      </section>
      <button-wrapper>
        <base-button type="submit" v-t="'auth.signInButton'" />
      </button-wrapper>
    </base-section>
  </form>
</template>

<script>
import { captureException } from '@sentry/browser';
import ButtonWrapper from '@/components/ButtonWrapper';
import store from '@/store';
import { sendQuizFormRequest } from '@/services/sendRestorePasswordLink';

export default {
  components: {
    ButtonWrapper,
  },
  props: {
    data: Object,
  },
  data: () => ({
    email: '',
    password: '',
    isRestorePasswordLinkSent: false,
    timeBeforeNextRestoreLinkSend: 0,
  }),
  methods: {
    goToWizard() {
      this.$router.push({
        name: 'wizard',
      });
    },
    handleSubmit(event) {
      event.preventDefault();
      this.rnAppMetricaReportEvent('create_site', store.appMetricaData);
      this.sendGAEvent('submit');
      this.$router.push({
        name: 'creating',
        params: {
          data: {
            ...this.data,
            email: this.email,
            passwordForAuth: this.password,
          },
        },
      });
    },
    async sendRestorePasswordLink() {
      try {
        await sendQuizFormRequest(this.email);
        this.isRestorePasswordLinkSent = true;
        this.timeBeforeNextRestoreLinkSend = 15;
        this.countdownBeforeNextRestorePassword();
      } catch (err) {
        if (err.name === 'UserNotFound') {
          this.$showError(this.$t('errors.UserNotFound'));
          return;
        }

        captureException(err);
        console.error(err);
        this.$showError(this.$t('errors.default'));
      }
    },
    countdownBeforeNextRestorePassword() {
      if (this.timeBeforeNextRestoreLinkSend < 0) {
        return;
      }

      setTimeout(() => {
        this.timeBeforeNextRestoreLinkSend -= 1;
        this.countdownBeforeNextRestorePassword();
      }, 1000);
    },
  },
  mounted() {
    if (!this.data) {
      this.goToWizard();
      return;
    }

    this.email = String(this.data.email);
  },
};
</script>

<style>
.restore-password-section {
  padding: 1em 0;
  color: #3b7694;
  font-size: 0.9em;
}

@media (max-width: 430px) {
  .restore-password-section {
    font-size: 0.8em;
  }
}

.restore-password-link {
  color: inherit;
}

.restore-password-link:hover {
  color: #338fff;
}
</style>
